module.exports = __webpack_public_path__ + "static/img/avgPlateHeight.25db192.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/avgPlateHeight.gif
// module id = gchX
// module chunks = 0